<template>
  <div class="sidebar-inplay">
    <!-- Main Categories -->
    <div v-if="inplayEvent?.length" class="geoff-bg-section rounded-3 py-2 mb-2">
      <div class="section-title geoff-border-bottom">In Play Event</div>
      <div
        v-for="event in inplayEvent"
        :key="`${event?.eventFile}${event?.eventGroup}`"
        class="section-line geoff-border-bottom-separator cursor-pointer"
        @click="selectEventCategory(event)"
        :class="{'active_category':isActiveEvent(event)}"
      >
        <div v-html="event?.sportSvg" class="sport-icon"></div>
        <div class="text-ellipsies">{{ event?.inPlayMatchName }}</div> 
      </div>
    </div>

    <!-- upcoming-->
    <div v-if="upcomingEvents?.length" class="geoff-bg-section rounded-3 py-2">
        <div class="section-title geoff-border-bottom">Upcoming In Play Events</div> 
      <div 
        v-for="event in upcomingEvents"
        :key="`${event?.eventFile}${event?.eventGroup}`"
      >
        <div
          class="section-line geoff-border-bottom-separator cursor-pointer"
          @click="goToEvent(event)"
        >
          <div v-html="event?.sportSvg" class="sport-icon"></div>
          <div class="text-ellipsies">{{ event?.inPlayMatchName }}</div> 
        </div>
      </div>
    </div>

  </div>
</template>

<script>

export default {
  name: "InplaySidebar",
  components: {},
  emits: ['inplay-event-selected'],
  props: {
    inplayEvent: {
      type: Array,
      default: () => { return  []}
    },
    upcomingEvents: {
      type: Array,
      default: () => { return  []}
    },
    selectedInplayEvent: {
      taype: Object
    },
  },
  data: ()=>{
    return {}
  },
  methods:{
    isActiveEvent(event) {
      return this.selectedInplayEvent?.eventFile === event?.eventFile
        && this.selectedInplayEvent?.eventGroup === event?.eventGroup
        && this.selectedInplayEvent?.sportcode === event?.sportcode
    },
    selectEventCategory(event) {
      this.$emit('inplay-event-selected', event)
    },

    goToEvent(event){
      const sport =  this.API.SPORTS.find(sport => sport.code === event?.sportcode)
      this.$router.push({
        name: 'matchEvent',
        params: {
            sportName: sport.title,
            ef: event.eventFile,
            eg: event.eventGroup
          },
        query: {
            title: event.inPlayMatchName,
          }
      })
    }
  }
}
</script>

<style scoped lang="scss">
  .sidebar-inplay {
    .section-title {
      font-weight: 600;
      padding: 0.5rem;
    }

    .section-line {
      display: flex;
      gap: 0.5rem;
      padding:0.5rem;

      .sport-icon {
          width: 1.375rem;
          height: 1.375rem;
          display: flex;
      }
    }
  }

  .active_category{
    box-shadow: inset 2px 0px 0 var(--geoff-accent);
    .slider-odd:not(.blank) {
      box-shadow: inset 0 0 0 1px var(--geoff-bg-btn-4);
      &.selected {
        box-shadow: inset 0 0 0 1px var(--geoff-outline-1);
      }
    }
  }
</style>